import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '../../../../../libraries/utils/components/icon';

class TextInputAdd extends Component {
  handleChange(event) {
    var value = event.target.value;
    this.props.onChange(value);
  }
  onClick() {
    var value = this.refs.inputField.value;
    this.props.onClick(value);
  }
  renderTooltipMessage() {
    var status = this.props.status,
      name = '';

    if (status.match(/success|error/)) {
      name = `validation-circle-${status}`;
    }

    return (
      <div className="icon-wrap">
        <Icon name={name} />
      </div>
    );
  }
  render() {
    var { title, description, placeholder, disabledAddButton, value, status } = this.props;
    var tooltipMessage = null;

    var inputClassNames = classnames('text-field-regular authorized-domains-input', {
      error: status === 'error',
      success: status === 'success',
      loading: status === 'loading'
    });

    if (status !== 'none') {
      tooltipMessage = this.renderTooltipMessage();
    }
    return (
      <div className="text-input-add">
        <div className="field">
          <div className="field-title">{title}</div>
          <div className="field-description">{description}</div>
          <div className="input-wrapper">
            <div className={inputClassNames}>
              {tooltipMessage}
              <input
                ref="inputField"
                type="text"
                value={value || ''}
                placeholder={placeholder}
                onChange={this.handleChange.bind(this)}
              />
            </div>
            <button
              disabled={disabledAddButton}
              className="add-button-input"
              onClick={this.onClick.bind(this)}
            >
              Add
            </button>
          </div>
        </div>
      </div>
    );
  }
}

TextInputAdd.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  placeholder: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  disabledAddButton: PropTypes.bool,
  value: PropTypes.string,
  status: PropTypes.oneOf(['error', 'success', 'none', 'loading'])
};

TextInputAdd.defaultProps = {
  value: ''
};

TextInputAdd.displayName = 'TextInputAdd';

export default TextInputAdd;
